import { DistributionPie } from './components/distribution-pie';

export function Analytics() {
  return <>
    <DistributionPie />
  </>;
}
